<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Add business post</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input
          [maxLength]="200"
          [(ngModel)]="businessPostData.postTitle"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
        [maxLength]="2000"
          [(ngModel)]="businessPostData.description"
          matInput
        ></textarea>
      </mat-form-field>
    </div>
   
    <div>
        <mat-form-field appearance="outline">
          <mat-label>External link</mat-label>
          <input
            
            [(ngModel)]="businessPostData.externalLink"
            matInput
            #input
          />
          
        </mat-form-field>
      </div>
      <div class="radio_group">
        <label>Post type: </label>
        <mat-radio-group [(ngModel)]="businessPostData.postType">
          <div class="brd_section_aliment">
          <div class="left_alint">
          <mat-radio-button [value]="2">Offer</mat-radio-button>
        </div>
      <div class="left_alint">
          <mat-radio-button [value]="3">Promotion</mat-radio-button>
        </div>
        <div class="left_alint">
          <mat-radio-button [value]="4">Job</mat-radio-button>
        </div>
      </div>
        </mat-radio-group>
      </div> 
  <div *ngFor="let asset of assetList; let i = index" style="display: flex; justify-content: center;">
      <div class="image-preview" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
        padding: 15px;
    ">
        <img [src]="asset.url" *ngIf="asset.assetType == 1" alt="" style="width: 300px; height: 170px; object-fit: cover;">

        <video #videoElement  width="300" controls class="gallery_img_vid" *ngIf="asset.assetType == 2">
          <source [src]="asset.url" type="video/mp4" />
      </video>

        <span (click)="removeAsset(i)" style="position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        background: #dd2c00;
        border-radius: 50%;
        height: 30px;
        width: 30px;" ><mat-icon style="    position: absolute;
      left: 3px;
      top: 2px;
      color: white;" class="material-icons-outlined">close</mat-icon></span>
      </div>

    </div>
     <div style="display: flex; justify-content: center; align-items: center">
    <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
  </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*, video/*"
          type="file"
          (change)="onUploadImage($event)"
        />
      </div>
    </div>

 



  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !businessPostData.postTitle ||
        !businessPostData.description || loader
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>
  </mat-dialog-actions>
  

      <div class="add_business_list">
 <h4 class="mb-3 fw-bold">Matter of Concern:</h4>
  <ul class="concern-list">
    <li class="concern-item">
      <div class="concern-number">1.</div>
      <div class="concern-text">Do not post hate speech, discrimination, or offensive language.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">2.</div>
      <div class="concern-text">Avoid harmful or illegal content.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">3.</div>
      <div class="concern-text">Do not post violent, graphic, or explicit material.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">4.</div>
      <div class="concern-text">Avoid spreading misinformation or fake news.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">5.</div>
      <div class="concern-text">Do not promote illegal activities like drugs, violence, piracy.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">6.</div>
      <div class="concern-text">Do not share personal information without consent.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">7</div>
      <div class="concern-text">Do not repost others' work without permission.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">8.</div>
      <div class="concern-text">Avoid nudity, political, or gambling ads.</div>
    </li>
    <li class="concern-item">
      <div class="concern-number">9.</div>
      <div class="concern-text">Violating the above restrictions, privacy policy, or terms of service can lead to post deletion and permanent account block.</div>
    </li>
  </ul>
</div>